import React from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { black } from 'Styles/colors';

const SessionEndMessage = ({ message }) => {
  const intl = useIntl();

  return (
    <Grid container justifyContent="center" alignItems="center" marginBottom="12px">
      <Typography fontSize="16px" textAlign="center" color={black._60} width="75%" margin="auto">
        {message.timestamp} {message.from} {intl.formatMessage({ id: 'direct-message.session-ended' })}
      </Typography>
    </Grid>
  );
};

SessionEndMessage.propTypes = {
  message: PropTypes.object,
};

export default SessionEndMessage;
